import React, { useEffect, useState } from 'react';
import { TableColumn } from 'react-data-table-component';
import { InputStatusModel } from 'features/worksheet/process/job/models';
import { Link } from 'react-router-dom';
import { MdOutlineCancel, MdOutlineCheckCircleOutline } from 'react-icons/md';
import { BiEditAlt } from 'react-icons/bi';
import DefaultModal from 'components/Modal/DefaultModal';
import JobChangeStatus from 'features/worksheet/process/job/components/JobChangeStatus';
import { useAppDispatch, useAppSelector } from 'helpers/redux';
import { RootState } from 'app/store';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import {
    getList,
    pendingJob,
    reset,
} from '../../../jobData/jobCheck/jobCheck.reducer';
import { customStatusOption, customWarnOption } from 'helpers/alertLabel';
import {
    cancelJob,
    checkJob,
    reset as resetJob,
} from 'features/worksheet/process/job/job.reducer';
import { AiOutlineHistory } from 'react-icons/ai';
import { HttpClientError, RequestStatus } from 'http-client';
import { JobCancel, JobCheck } from '../../../jobData/jobCheck/models';
import moment from 'moment-timezone';
import DataTableServerPaging from 'components/Table/DataTableServerPaging';
import { conditionalRowStyles } from 'helpers/table';
import { DETAIL_TYPE_JOB_INPUT } from '../../job/constants';
import AgDataGrid from '../../../../../components/DataGrid/AgDataGrid';
import { filterParams } from '../../../../../helpers/agTable';
import { rowNumberRenderer } from '../../../../../components/DataGrid/agGridCustomProps';
import { UserCredential } from '../../../../login/models';
import {
    getCancelMRE,
    waitingMRE,
    reset as resetMRE,
} from '../processMRE.reducer';
import FormLoader from 'components/Loader/FormLoader';

const CancelMRETable = () => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);

    const user = useAppSelector(
        (state: RootState) => state.user.userAuth ?? ({} as UserCredential),
    );
    const rows = useAppSelector(
        (state: RootState) => state.processMRE.cancelRows ?? 0,
    );
    const isLoading = useAppSelector(
        (state: RootState) => state.processMRE.isGetCancelMRELoading ?? false,
    );
    const jobCancelList = useAppSelector(
        (state: RootState) => state.processMRE.cancelMREList ?? [],
    );
    const actionStatus = useAppSelector(
        (state: RootState) => state.job.actionStatus,
    );
    const error = useAppSelector(
        (state: RootState) => state.job.error ?? ({} as HttpClientError),
    );
    const actionPendingStatus = useAppSelector(
        (state: RootState) => state.jobCheck.actionStatus,
    );
    const errorPending = useAppSelector(
        (state: RootState) => state.jobCheck.error ?? ({} as HttpClientError),
    );
    const actionMREStatus = useAppSelector(
        (state: RootState) => state.processMRE.actionStatus,
    );
    const errorMRE = useAppSelector(
        (state: RootState) => state.processMRE.error ?? ({} as HttpClientError),
    );
    const userState = useAppSelector(
        (state: RootState) => state.user.userAuth ?? ({} as UserCredential),
    );

    const [showModal, setShowModal] = useState<boolean>(false);
    const [action, setAction] = useState<string>('');
    const [jobId, setJobId] = useState<string>('');
    const [tableName, setTableName] = useState('');

    useEffect(() => {
        dispatch(getCancelMRE());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (
            tableName === 'cancel' &&
            actionStatus !== undefined &&
            actionStatus !== RequestStatus.pending
        ) {
            MySwal.fire(
                customStatusOption(
                    actionStatus === RequestStatus.success,
                    error.data?.message,
                    'status has been changed!',
                    'failed to change status',
                ),
            ).then(() => {
                dispatch(resetJob());
                dispatch(getCancelMRE());
                setShowModal(false);
                setTableName('');
            });
        } else if (
            tableName === 'cancel' &&
            actionPendingStatus !== undefined &&
            actionPendingStatus !== RequestStatus.pending
        ) {
            MySwal.fire(
                customStatusOption(
                    actionPendingStatus === RequestStatus.success,
                    errorPending.data?.message,
                    'status has been changed!',
                    'failed to change status',
                ),
            ).then(() => {
                dispatch(reset());
                dispatch(getCancelMRE());
                setShowModal(false);
                setTableName('');
            });
        } else if (
            tableName === 'cancel' &&
            actionMREStatus !== undefined &&
            actionMREStatus !== RequestStatus.pending
        ) {
            MySwal.fire(
                customStatusOption(
                    actionMREStatus === RequestStatus.success,
                    errorMRE.data?.message,
                    'status has been changed!',
                    'failed to change status',
                ),
            ).then(() => {
                dispatch(resetMRE());
                dispatch(getCancelMRE());
                setShowModal(false);
                setTableName('');
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        actionStatus,
        actionPendingStatus,
        actionMREStatus,
        error,
        errorPending,
        errorMRE,
    ]);

    const toggleModal = () => {
        setShowModal((prevState) => !prevState);
        setAction('');
        setJobId('');
    };

    const openModal = (action: string, id: string) => {
        setAction(action);
        setShowModal(true);
        setJobId(id);
    };

    const onStatusClicked = (
        id: string,
        action: string,
        data?: InputStatusModel,
    ) => {
        MySwal.fire(
            customWarnOption(
                'Change Status',
                'Are you sure you want to change the status',
            ),
        ).then((result) => {
            if (result.isConfirmed) {
                switch (action) {
                    case 'checked':
                        dispatch(
                            checkJob({ job_id: id, user_id: user.user_id }),
                        );
                        setTableName('cancel');
                        break;
                    case 'pending':
                        dispatch(pendingJob({ id, userId: userState.user_id }));
                        setTableName('cancel');
                        break;
                    case 'cancel':
                        dispatch(
                            cancelJob({
                                job_id: id,
                                cancel_notes: data?.notes ?? '',
                                waiting_by_user: user.user_id,
                            }),
                        );
                        setTableName('cancel');
                        break;
                    case 'reverse':
                        dispatch(
                            waitingMRE({
                                job_id: id,
                                waiting_notes: data?.notes ?? '',
                                waiting_subject_id: '',
                                waiting_by_user: user.user_id,
                            }),
                        );
                        setTableName('cancel');
                        break;
                    default:
                        break;
                }
            }
        });
    };

    const columns: TableColumn<JobCancel>[] = [
        {
            name: 'NO.',
            width: '60px',
            cell: (_d: any, index: number) => index + 1,
        },
        {
            name: 'Sales Order',
            selector: (row) => row.sales_order,
            sortable: true,
        },
        {
            name: 'ID Number',
            selector: (row) => row.number_id,
            sortable: true,
        },
        {
            name: 'Job Number',
            selector: (row) => row.number_job,
            format: (row) => (
                <Link
                    to={`/worksheet/job-detail/${DETAIL_TYPE_JOB_INPUT}/${row.number_id}`}
                    className="underline text-blue-700"
                >
                    {row.number_job}
                </Link>
            ),
            sortable: true,
        },
        {
            name: 'Project',
            selector: (row) => row.project_name,
            sortable: true,
        },
        {
            name: 'KoJ',
            selector: (row) => row.kind_name,
            sortable: true,
        },
        {
            name: 'Waiting Subject',
            selector: (row) => row.waiting_subject_name,
            sortable: true,
        },
        {
            name: 'Request Date',
            selector: (row) =>
                new Date(row.ts_created).toLocaleDateString('en-US'),
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => row.status_name,
            sortable: true,
        },
        {
            name: 'Type',
            selector: (row) => row.type_name,
            sortable: true,
        },
        {
            name: 'District',
            selector: (row) => row.district_name,
            sortable: true,
        },
        {
            name: 'Due Date',
            selector: (row) =>
                new Date(row.date_due).toLocaleDateString('en-US'),
            sortable: true,
        },
        {
            name: 'Req Pole',
            selector: (row) => row.pole_total,
            sortable: true,
        },
        {
            name: 'Last Checked',
            width: '160px',
            selector: (row) =>
                moment(new Date(row.waiting_ts), '').format(
                    'MM/DD/YYYY HH:mm:ss',
                ),
            sortable: true,
        },
        {
            name: 'Canceled By',
            selector: (row) => row.cancel_by_user_name,
            sortable: true,
        },
        {
            name: 'Canceled Notes',
            selector: (row) => row.cancel_notes ?? '-',
            sortable: true,
        },
    ];

    const ActionCellRender = (props: any) => {
        return (
            <div className="flex align-middle h-[100%]">
                <button
                    onClick={() => onStatusClicked(props.data?.id, 'reverse')}
                >
                    <MdOutlineCheckCircleOutline className="text-2xl text-primary-color" />
                </button>
            </div>
        );
    };

    const [columnDefs, _setColumnDefs] = useState([
        {
            headerName: '#',
            field: 'rowNumber',
            maxWidth: 50,
            cellRenderer: rowNumberRenderer, // Use the custom cell renderer
        },
        { field: 'sales_order', headerName: 'Sales Order', filter: true },
        { field: 'number_id', headerName: 'ID Number', filter: true },
        { field: 'number_job', headerName: 'Job Number', filter: true },
        {
            field: 'project_name',
            headerName: 'Project',
            filter: 'agTextColumnFilter',
        },
        { field: 'kind_name', headerName: 'KoJ', filter: 'agTextColumnFilter' },
        // {
        //     field: 'waiting_subject_name',
        //     headerName: 'Waiting Subject',
        //     filter: 'agTextColumnFilter',
        // },
        {
            field: 'ts_created',
            headerName: 'Request Date',
            filter: 'agDateColumnFilter',
            filterParams: filterParams,
            cellDataType: 'date',
        },
        { field: 'status_name', headerName: 'Status', filter: true },
        {
            field: 'cancel_by_user_name',
            headerName: 'Canceled By',
            filter: false,
            sortable: false,
        },
        {
            field: 'cancel_notes',
            headerName: 'Canceled Notes',
            filter: false,
            sortable: false,
        },
        { field: 'type_name', headerName: 'Type', filter: true },
        { field: 'district_name', headerName: 'District' },
        {
            field: 'date_due',
            headerName: 'Due Date',
            filter: 'agDateColumnFilter',
            filterParams: filterParams,
            cellDataType: 'date',
        },
        { field: 'pole_total', headerName: 'Req Pole' },
        {
            field: 'waiting_ts',
            headerName: 'Last Checked',
            filter: 'agDateColumnFilter',
            filterParams: filterParams,
            cellDataType: 'date',
        },
        {
            headerName: 'Actions',
            field: 'actions',
            pinned: 'right',
            suppressCellFlash: true,
            minWidth: 100,
            cellRenderer: ActionCellRender,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }),
        },
    ]);

    const handlePagingChange = (rowsPerPage: number, page: number) => {
        dispatch(getCancelMRE());
    };

    return (
        <div>
            <div className="main-data-grid mt-5">
                <FormLoader isLoading={isLoading} label={'Fetching Data'}>
                    <AgDataGrid
                        rowData={jobCancelList}
                        columnDefs={columnDefs}
                    />
                </FormLoader>
                <DefaultModal
                    title="Change Status"
                    show={showModal}
                    onClose={toggleModal}
                    body={
                        <JobChangeStatus
                            action={action}
                            jobId={jobId}
                            onSubmit={onStatusClicked}
                        />
                    }
                />
            </div>
        </div>
    );
};

export default CancelMRETable;
